import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const pizzaNames = [
  "Cheese", "Pepperoni", "Veggie", "Hawaiian",
  "Margherita", "Meat Lovers", "BBQ Chicken",
];

const prices = [10, 12, 15, 18, 20];

const getRandomPrice = () => prices[Math.floor(Math.random() * prices.length)];
const getRandomName = () => pizzaNames[Math.floor(Math.random() * pizzaNames.length)];

const PizzaParlorTaxTime = () => {
  const [pizzas, setPizzas] = useState([]);
  const [final1, setFinal1] = useState('');
  const [final2, setFinal2] = useState('');
  const [result, setResult] = useState('');

  const generatePizzas = () => {
    const newPizzas = Array.from({ length: 4 }, () => {
      const name = getRandomName();
      const price = getRandomPrice();
      const tax = price * 0.10;
      const final = (price + tax).toFixed(2);
      return { name, price, tax, final };
    });

    setPizzas(newPizzas);
    setFinal1('');
    setFinal2('');
    setResult('');
  };

  const checkPizzaTotal = () => {
    const f1 = parseFloat(final1);
    const f2 = parseFloat(final2);
    if (isNaN(f1) || isNaN(f2)) {
      setResult("⚠️ Enter both final prices!");
      return;
    }
    const total = f1 + f2;
    setResult(`✅ Total Price: $${total.toFixed(2)}`);
         const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
  };

  useEffect(() => {
    generatePizzas();
  }, []);

  const styles = {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: "'Comic Sans MS', cursive, sans-serif",
      background: 'linear-gradient(to bottom, #fff7e6, #ffd699)',
      textAlign: 'center',
      minHeight: '100vh',
      boxSizing: 'border-box'
    },
    header: {
      backgroundColor: '#ff8c1a',
      padding: '20px',
      color: 'white',
      fontSize: 'clamp(1.5rem, 5vw, 2.5rem)'
    },
    board: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      margin: '30px auto',
      gap: '15px',
      maxWidth: '1000px'
    },
    pizza: {
      backgroundColor: 'white',
      border: '3px dashed #ffa64d',
      borderRadius: '20px',
      padding: '20px',
      width: 'clamp(240px, 30%, 280px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
      textAlign: 'left'
    },
    pizzaTitle: {
      marginTop: 0,
      color: '#cc6600',
      fontSize: 'clamp(1.2rem, 3vw, 1.5rem)'
    },
    inputRow: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      flexWrap: 'wrap',
      margin: '1.5rem auto'
    },
    input: {
      width: '100px',
      padding: '8px',
      borderRadius: '6px',
      border: '2px solid #ffb84d',
      fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
      textAlign: 'center'
    },
    button: {
      margin: '15px 10px',
      padding: '12px 24px',
      fontSize: 'clamp(1rem, 3vw, 1.2rem)',
      backgroundColor: '#ff8c1a',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer'
    },
    result: {
      fontSize: 'clamp(1rem, 3vw, 1.3rem)',
      fontWeight: 'bold',
      marginTop: '20px'
    }
  };

  return (
    <div style={styles.body}>
      <header style={styles.header}>🍕 Pizza Parlor Tax Time</header>
      <p style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', margin: '1rem auto' }}>
        Each pizza comes with a 10% Pizza Tax! Calculate the final price after tax.
      </p>

      <div style={styles.board}>
        {pizzas.map((pizza, idx) => (
          <div key={idx} style={styles.pizza}>
            <h3 style={styles.pizzaTitle}>🍕 {pizza.name} Pizza</h3>
            <p>Price: ${pizza.price}</p>
            <p>Tax: 10%</p>
            <p><em>What is the final price?</em></p>
            <p><small>Hint: 10% of ${pizza.price} = {pizza.tax.toFixed(2)}</small></p>
          </div>
        ))}
      </div>

      <p style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}>
        Enter the final price of any 2 pizzas (after tax):
      </p>

      <div style={styles.inputRow}>
        <input
          type="number"
          placeholder="Pizza 1"
          style={styles.input}
          value={final1}
          onChange={(e) => setFinal1(e.target.value)}
        />
        +
        <input
          type="number"
          placeholder="Pizza 2"
          style={styles.input}
          value={final2}
          onChange={(e) => setFinal2(e.target.value)}
        />
      </div>

      <div>
        <button style={styles.button} onClick={checkPizzaTotal}>Check Total</button>
        <button style={styles.button} onClick={generatePizzas}>Next Order 🍕🔄</button>
      </div>

      <div style={styles.result}>{result}</div>
    </div>
  );
};

export default PizzaParlorTaxTime;
